import vpayEnEG from './localization/vpay/en-EG.json';
import vpayArEG from './localization/vpay/ar-EG.json';
import vpayEnSA from './localization/vpay/en-SA.json';
import vpayArSA from './localization/vpay/ar-SA.json';
import settingsEnEG from './localization/settings/en-EG.json';
import settingsArEG from './localization/settings/ar-EG.json';
import settingsEnSA from './localization/settings/en-SA.json';
import settingsArSA from './localization/settings/ar-SA.json';
import { mapTransactionContent } from './transactions.adapter';
import { mapTransferContent, mapTransferDetailContent } from './transfers.adapter';
import {
  mapBankAccountFormContent,
  mapBankAccountSummaryContent,
  mapEmptyBankAccountContent,
} from './bank-account.localization';
import emptyBankIllustration from './card-unavailable.svg';

const translations = {
  'en-EG': [vpayEnEG, settingsEnEG],
  'ar-EG': [vpayArEG, settingsArEG],
  'en-SA': [vpayEnSA, settingsEnSA],
  'ar-SA': [vpayArSA, settingsArSA],
};

export const getContent = culture => {
  const [vpay, settings] = translations[culture] || translations['en-EG'];
  return {
    vpay,
    settings,
    dashboard: {
      balance: vpay.balanceBanner,
      tabs: vpay.transactionsTabs,
      searchAndFilter: vpay.searchAndFilter,
      loadMore: vpay.loadMoreBtn.loadMore,
      empty: vpay.noPayments,
    },
    transactions: mapTransactionContent(vpay),
    transfers: mapTransferContent(vpay),
    transferDetail: mapTransferDetailContent(
      vpay.transferDetailes,
      vpay.transfersTable,
      vpay.transactionsTable,
    ),
    bankForm: mapBankAccountFormContent({
      ...vpay.bankInfo,
      bankSelectModal: vpay.bankSelectModal,
    }),
    settingsBankForm: mapBankAccountFormContent(settings.bankInfo),
    bankSummary: mapBankAccountSummaryContent(settings.bankAccountInfo),
    emptyBank: mapEmptyBankAccountContent(settings.emptyBankAccount),
    emptyBankIllustration,
    status: {
      loading: vpay.transactionsTable.loading,
      error: vpay.transfersTable.error,
      retry: vpay.transfersTable.retry,
    },
  };
};
